export default {
  common: {
    back: '← Back',
    backHome: '← Back to Home',
    loading: 'Loading...',
    submitting: 'Submitting...',
    querying: 'Querying...',
    retry: 'Search Again',
    pageTitle: 'Shaiya - Card Platform',
    updateTitle: 'This page is out of date',
    updateBody: 'A new redeem page ({version}) is available. Refresh to load it and clear the local queue cache. Your CDK is not affected.',
    updateRefresh: 'Refresh and clear cache',
  },
  home: {
    brand: 'Shaiya - Card Platform',
    brandSub: 'Redeem',
    eyebrow: 'SHAIYA · VOID',
    heroTitle: 'Redeem',
    heroSub: 'Session check first. Once accepted, refresh later — delivery is final. Do not submit twice.',
    ctaPrimary: 'Redeem now',
    ctaProgress: 'Progress',
    flowTitle: 'Three steps',
    chips: {
      session: 'OK after session check',
      handoff: 'Accepted · pending delivery',
      once: 'Do not resubmit',
    },
    services: {
      recharge: { title: 'Redeem', en: 'Redeem', cta: 'Start', p1: 'Enter code, pass session, then open', p2: 'Submit session', p3: 'Confirm' },
      batch: { title: 'Batch', en: 'Batch', cta: 'Start batch', p1: 'Redeem multiple codes in order', p2: 'Import Excel sessions', p3: 'Match and submit' },
      lookup: { title: 'Lookup', en: 'Lookup', cta: 'Check code', p1: 'See usage and recharge email', p2: 'See if used', p3: 'Show email' },
      progress: { title: 'Progress', en: 'Progress', cta: 'View progress', p1: 'Check by code or local queue' },
      billing: { title: 'Billing', en: 'Billing', cta: 'Check billing', p1: 'Paste session to view subscription', p2: 'Query billing', p3: 'View subscription' },
    },
    flows: {
      submit: { title: 'Submit', s1: 'Enter code and confirm plan', s2: 'Check session — OK when it passes', s3: 'Opened. Refresh later; delivery is final' },
      batch: { title: 'Batch Redeem', s1: 'Verify CDKs — batch preview', s2: 'Import sessions — Excel/CSV auto-detect', s3: 'Match & submit — redeem in order and track progress' },
      lookup: { title: 'CDK Status', s1: 'Enter CDK — full code', s2: 'Check status — used or not', s3: 'See email — which account was recharged' },
      billing: { title: 'Billing Lookup', s1: 'Session input — paste your token', s2: 'Query billing — click to look up', s3: 'Result — shown after the query' },
    },
  },
  progress: {
    title: 'Progress',
    subtitle: 'Look up by code, or wait for delivery',
  },
  redeemTabs: {
    single: 'Redeem Now',
    batch: 'Batch Redeem',
    lookup: 'CDK Status',
    billing: 'Billing',
    progress: 'Progress',
  },
  batch: {
    title: 'Batch Redeem',
    subtitle: 'Verify CDKs → pair Session or email/password → submit and watch progress',
    panelTitle: 'Batch Redeem',
    panelHint: 'Verify CDKs → choose Session or email/password → match and submit in order',
    cdkListLabel: 'CDK list (one per line, max {max})',
    cdkPlaceholder: 'SXC-XXXX-XXXX-XXXX-XXXX\n…',
    cdkRecognized: '{n} CDKs detected',
    cdkQueueHint: 'Large batches run with limited concurrency — ensure upstream capacity',
    credMode: 'Credential mode',
    modeSession: 'Session',
    modeMailbox: 'Email + password',
    mailboxLabel: 'Email/password list (one per line)',
    mailboxPlaceholder: 'email----password\nemail:password\nemail,password',
    mailboxLinePlaceholder: 'email----password or email:password',
    mailboxRecognized: '{n} mailboxes detected',
    mailboxImportBtn: 'Import Excel / CSV / TXT (email + password)',
    mailboxHint: 'Supports mail.tm / Outlook. Format: email----password; Excel needs email + password columns',
    mailboxPairHint: 'Pairing: 1st valid CDK ↔ 1st mailbox, and so on. Live progress shows account and card last4.',
    excelLabel: 'Session Excel (optional)',
    clearImport: 'Clear import',
    importing: 'Parsing…',
    imported: '{n} imported · click to replace',
    importBtn: 'Import Excel / CSV (auto-detect session column)',
    excelHint: 'Supports xlsx / csv. gptbuy format “email,email password,GPT password,token,session” uses the session column. Redeem needs full Session JSON (with sessionToken) or 5-part JWE — not bare Access Token',
    verifying: 'Verifying…',
    verifyStart: 'Verify batch and start',
    verifyingKeys: 'Verifying CDKs…',
    statTotal: 'Total',
    statWait: 'Awaiting credential',
    statRun: 'Running',
    statOkFail: 'OK / Fail',
    currentOrdinal: '{n} / {total}',
    remaining: '{n} left',
    willUseAccount: 'Using account:',
    sessionPlaceholder: 'Paste full Session JSON (must include sessionToken) or 5-part JWE; auto-filled after import',
    submitting: 'Submitting…',
    submitNext: 'Submit and continue',
    autoSubmitting: 'Auto-submitting…',
    autoSubmit: 'Auto-submit all (CDK×credential by order, {n} in pool)',
    pairHint: 'Pairing: 1st valid CDK ↔ 1st Excel session, and so on. Progress updates below after submit.',
    allSubmitted: 'All credentials submitted ({n})',
    watchProgress: 'Keep watching progress below',
    exportOk: 'Export successful accounts ({n})',
    noValidKeys: 'No valid CDKs to redeem',
    liveProgress: 'Live progress',
    account: 'Account',
    card: 'Card',
    cardPending: 'Last4 after card open',
    reset: 'Back · start over',
    status: {
      pending_verify: 'Pending',
      verify_ok: 'Valid',
      verify_fail: 'Invalid',
      waiting_session: 'Need credential',
      submitting: 'Submitting',
      processing: 'Processing',
      success: 'Success',
      failed: 'Failed',
    },
  },
  recharge: {
    title: 'Redeem',
    subtitle: 'Check the code and account first. Activation starts only if both pass.',
    steps: { s1: 'Verifying', s2: 'Preparing', s3: 'Paying', s4: 'Done' },
    flow: {
      verify: 'Verifying',
      prepare: 'Preparing',
      pay: 'Paying',
      done: 'Completed',
      orderNo: 'Order',
      copy: 'Copy',
      copied: 'Copied',
      success: 'Top-up succeeded. Refresh ChatGPT to check membership.',
      sessionOk: 'Session looks valid',
      needCode: 'Enter a usable code first',
      needCred: 'Code is valid. Paste a Session below.',
      checkingAccount: 'Checking the account plan…',
      subCanOpen: '{current} — can open {target}',
      subCovered: '{current} — already same or higher',
      back: 'Back',
      loading: 'Activating',
      queuedHint: 'You don’t have to stay on this page. Start another while this one keeps updating in the local queue.',
      openAnother: 'Redeem another',
    },
    verifyCode: 'Verify code',
    verifyHint: 'Verify the code first. Session appears after it passes.',
    redeemNow: 'Redeem now',
    currentSub: 'Current plan',
    devPreview: 'Local preview',
    phaseChecking: 'Checking',
    phaseAccepted: 'Accepted',
    phaseForm: 'Form',
    usedNoticeTitle: 'This CDK has already been used',
    usedNoticeEmail: 'Recharge email',
    usedNoticeHint: 'This CDK is already redeemed. Do not submit Session again.',
    step1Title: 'Verify code',
    cdkPlaceholder: 'Enter your code',
    codeValid: 'Code is valid. Continue.',
    verifying: 'Checking…',
    previewNext: 'Preview / Next',
    continueNext: 'Next',
    step2Title: 'ChatGPT credential',
    modeSession: 'Session',
    modeMailbox: 'Email',
    sessionGuideBefore: 'Open',
    sessionGuideCopy: 'copy the ',
    sessionGuideJson: 'full JSON',
    sessionGuideAfter: '(must include sessionToken). Bare Access Token is disabled.',
    emailPlaceholder: 'email@outlook.com',
    passwordPlaceholder: 'Email password',
    prev: 'Back',
    startOpen: 'Start',
    checking: 'Checking…',
    sessionPassed: 'Session passed',
    checkingSession: 'Checking Session…',
    accountVerified: 'Account verified',
    checkingHint: 'Checking whether this account can be opened. Usually 7–15s',
    checkingSlowHint: 'This is taking longer than usual. You can leave and check progress later — no need to keep this page open.',
    retryOpen: 'Try again',
    targetPlan: 'Target plan',
    accepted: 'Accepted',
    handoff: 'Accepted and processing. Refresh later — delivery is final. Contact support if it does not arrive. Do not submit twice.',
    continueRedeem: 'Redeem another',
    viewProgress: 'View progress',
    step3Title: 'Confirm redeem',
    confirmHint: 'Confirm the account, then open. If it does not go through, the code is still unused and you can try again.',
    currentPlan: 'Current plan',
    subStatus: 'Subscription',
    subUntil: 'Plan ends',
    remaining: 'Remaining',
    autoRenew: 'Auto-renew',
    lastPayAt: 'Last payment time',
    lastPay: 'Last payment',
    payMethod: 'Payment method',
    noAccountSummary: 'Account recognized. You can continue.',
    delinquentHint: 'This account may have an unpaid bill. Opening may be less reliable.',
    alreadySatisfiedBtn: 'Plan already met',
    redeem: 'Redeem',
    submitting: 'Submitting…',
    localQueue: 'Local queue',
    queueCount: 'Local queue · {n}',
    queueOpenCount: '{n} in progress',
    queueSyncing: 'Syncing',
    queueExpand: 'Expand',
    queueCollapse: 'Collapse',
    queueNoEmail: 'No account yet',
    queueBoundSession: 'Session bound',
    sessionEmailFound: 'Account: {email}',
    sessionUserFound: 'Account found',
    step4Title: 'Redeem progress',
    stage: 'Stage',
    polling: 'Live polling (~1s)',
    finished: 'Finished',
    redeemAccount: 'Account',
    bankCard: 'Card',
    cardPending: 'Last4 after card open',
    progressAccept: 'Accepted',
    progressCard: 'Card / funds',
    progressPay: 'Payment',
    progressDone: 'Opened',
    timeline: 'Details',
    waitingEvents: 'Submitted. Waiting for step details…',
    rawDebug: 'Raw response (debug)',
    redeemFailed: 'Opening did not finish. The code is still unused.',
    redeemDone: 'Opened. Confirm the plan on the ChatGPT account.',
    notice: {
      sessionTitle: 'Sign-in expired',
      sessionBody: 'Open the ChatGPT Session page again, copy the full JSON, then retry.',
      busyTitle: 'Still preparing',
      busyBody: 'Wait a moment, then tap Confirm. Your code is still unused.',
      satisfiedTitle: 'Plan already covered',
      satisfiedBody: 'This account already has the same or a higher plan.',
      usedTitle: 'Code already used',
      usedBody: 'This code has already been redeemed.',
      invalidTitle: 'Code unavailable',
      invalidBody: 'Check the code, or contact the issuer.',
      need_sessionTitle: 'Paste a Session first',
      need_sessionBody: 'The full JSON with sessionToken is required. An Access Token alone will not work.',
      need_mailboxTitle: 'Enter email and password',
      need_mailboxBody: 'Fill these in, then tap Confirm to redeem.',
      need_codeTitle: 'Enter a code first',
      need_codeBody: 'Paste the full code to continue.',
      failedTitle: 'Opening did not finish',
      failedBody: 'The code is still unused. Try again later, or contact support.',
      processingTitle: 'Processing',
      processingBody: 'Please wait. Do not submit again.',
      doneTitle: 'Opened',
      doneBody: 'Confirm the plan on the ChatGPT account.',
      delinquentTitle: 'Billing issue on this account',
      delinquentBody: 'You can still try, but it may be less reliable.',
      account_busyTitle: 'Account already opening',
      account_busyBody: 'This account already has an opening in progress. Wait for the first card, then redeem again. This code is still unused.',
    },
    resultOpening: 'Opening',
    resultReady: 'Ready',
    redeemAgain: 'Redeem another',
    subActive: 'Active',
    subExpired: 'Expired / Free',
    upstreamUnknown: 'Not provided',
    renewYes: 'Renews after expiry',
    renewNo: 'Will not renew',
    paid: 'Paid',
    cardExpiry: 'Card expires',
    defaultPay: 'Default payment method',
    expired: 'Expired',
    daysHours: '{d}d {h}h',
    hoursMinutes: '{h}h {m}m',
    minutesOnly: '{m}m',
    planFree: 'Free',
    satisfiedRenew: 'This account already has {plan} or higher until {until} and will auto-renew. It cannot be purchased again before cancel + expiry.',
    satisfiedNoRenew: 'This account already has {plan} or higher. Earliest repurchase: {until}.',
    satisfiedUntil: 'This account already has {plan} or higher until {until}. Cannot repurchase now.',
    satisfied: 'This account already has {plan} or higher. Cannot repurchase this time.',
    errEnterCode: 'Enter a code',
    errInvalidCode: 'Invalid or unavailable code',
    errNoToken: 'Code preview failed. Try again shortly',
    errNeedSession: 'Paste the full Session JSON (must include sessionToken). Access Token alone is not accepted',
    errNeedMailbox: 'Enter email and password',
    errPreflight: 'Preflight failed',
    errNoPreflight: 'Account check did not finish. Go back, confirm credentials, then retry',
    allocating: 'Allocating an opening resource, please wait…',
    allocatingTimeout: 'The opening resource is still being prepared. Tap Start again in a moment',
    errRejected: 'Redeem rejected',
    queueOpened: 'Opened',
    queueAccepted: 'Accepted',
    queueReview: 'In review',
    queueFailed: 'Failed',
    queueProcessing: 'Processing',
    queueUnused: 'Unused',
    stepQueued: 'Queued',
    stepCredential: 'Credential check',
    stepPricing: 'Pricing',
    stepCheckout: 'Card / bind',
    stepPayment: 'Payment',
    stepSubscription: 'Subscription',
    stepInvoice: 'Invoice',
    stepRenewal: 'Renewal',
    stepReconcile: 'Reconcile',
    stepCompleted: 'Done',
    stepPending: 'Processing',
  },
  cdkLookup: {
    title: 'CDK Status',
    subtitle: 'Check whether a CDK is used and which email was recharged (no token)',
    queryTitle: 'Enter CDK',
    queryHint: 'Enter the full CDK. Only use-status and recharge email are returned — never session/token.',
    cdkLabel: 'CDK Code',
    cdkPlaceholder: 'SXC-XXXX-XXXX-XXXX-XXXX',
    cdkPlaceholderMulti: 'One CDK per line, bulk lookup supported\nSXC-XXXX-XXXX-XXXX-XXXX',
    batchCount: '{n} CDK(s)',
    queryBtn: 'Check CDK Status',
    resultTitle: 'Result',
    cdkCode: 'CDK',
    useStatus: 'Use status',
    rechargeEmail: 'Recharge email',
    emailEmpty: '—',
    plan: 'Plan',
    usedAt: 'Used at',
    queryOther: 'Check another CDK',
    msgUsed: 'This CDK has been used.',
    msgUnused: 'This CDK has not been used yet.',
    msgProcessing: 'This CDK redeem is in progress.',
    errNotFound: 'CDK not found',
    errEmpty: 'Enter at least one CDK',
    errTooMany: 'Up to {n} CDKs per query',
    errNetwork: 'Network error, please retry',
    status: {
      unused: 'Unused',
      used: 'Used',
      disabled: 'Disabled',
      expired: 'Expired',
      processing: 'Processing',
      unknown: 'Unknown',
    },
  },

  dashboard: {
    title: 'Billing Tool',
    subtitle: 'Billing Tool · Query account subscription and billing',
    step1Title: 'Paste Session to Query',
    hint: 'Paste the session JSON or access token you want to check.',
    inputLabel: 'Session JSON or access token',
    inputPlaceholder: 'Paste session JSON or access token',
    inputExample: 'e.g. {"access_token":"sk-xxx"} or paste the token directly',
    queryBtn: 'Query Billing',
    resultTitle: 'Billing Result',
    accountInfo: 'Account Info',
    email: 'Email',
    subStatus: 'Subscription',
    currentPlan: 'Current Plan',
    billingInfo: 'Billing Info',
    billingAmount: 'Amount',
    currency: 'Currency',
    nextBilling: 'Next Billing Date',
    queryOther: 'Query Another Account',
    notFoundTitle: 'No billing found for this session',
    notFoundHint: 'Please check whether the session is correct',
    msgActive: '✓ Subscription active, account is in good standing',
    msgInactive: '⚠ Subscription inactive, please check billing info',
    msgExpired: '✗ Subscription expired, please update payment info',
    errQueryFailed: 'Query failed',
    errNetwork: 'Network error, please try again',
    status: { active: 'Active', inactive: 'Inactive', expired: 'Expired' },
  },
  login: {
    title: 'Admin Login',
    subtitle: 'Log in to the admin console for CDK issue, redeem recon and site settings.',
    username: 'Username',
    usernamePlaceholder: 'Enter username',
    password: 'Password',
    passwordPlaceholder: 'Enter password',
    loginBtn: 'Sign In',
    loggingIn: 'Signing in...',
    errLoginFailed: 'Login failed',
    errNetwork: 'Network error, please try again later',
  },
  notFound: {
    title: 'Page Not Found',
    home: 'Back to Home',
  },
}
